import DSHttpAdapter from 'js-data-http';
import _ from 'lodash'

const httpAdapter = new DSHttpAdapter({
  // basePath: process.env.API_HOST,
  // serialize (config, data) {
  //   console.log('serialize', config, data)
  // },
  httpConfig: {
    cache: false,
    headers: {
      common: {
        'Cache-Control': 'no-cache',
        'token': sessionStorage.getItem('token')
      },
      get: {
        'If-Modified-Since': 0
      }
    }
  }
});

export default httpAdapter



// WEBPACK FOOTER //
// ./src/store/adapters/http.js